export default __webpack_public_path__ + "static/desktop_sek2_KV10-8b5ea0adc2109d0732dc51a67849db00.mp4";